"use client";
import _extends from '@babel/runtime/helpers/extends';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { pagination, item, button, truncated } from './styles.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { ThemeProvider } from 'styled-components';
import { IconChevronRight } from '../icons/ui_navigation/IconChevronRight.web.js';
import { useSmartControlled } from '../utils/hooks/useSmartControlled.js';

var _excluded = ["pages", "active", "onPageChange", "tag", "color", "aria-label", "ariaGotoNextLabel", "ariaGotoPreviousLabel", "ariaGotoPageLabel", "buttonProps"];
var noop = function noop() {
  return {};
};
var Pagination = function Pagination(_ref) {
  var pages = _ref.pages,
    activeProp = _ref.active,
    onPageChange = _ref.onPageChange,
    _ref$tag = _ref.tag,
    tag = _ref$tag === undefined ? 'button' : _ref$tag,
    color = _ref.color,
    _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === undefined ? 'Pagination' : _ref$ariaLabel,
    _ref$ariaGotoNextLabe = _ref.ariaGotoNextLabel,
    ariaGotoNextLabel = _ref$ariaGotoNextLabe === undefined ? 'Go to Next Page' : _ref$ariaGotoNextLabe,
    _ref$ariaGotoPrevious = _ref.ariaGotoPreviousLabel,
    ariaGotoPreviousLabel = _ref$ariaGotoPrevious === undefined ? 'Go to Previous Page' : _ref$ariaGotoPrevious,
    _ref$ariaGotoPageLabe = _ref.ariaGotoPageLabel,
    ariaGotoPageLabel = _ref$ariaGotoPageLabe === undefined ? 'Go to Page' : _ref$ariaGotoPageLabe,
    _ref$buttonProps = _ref.buttonProps,
    buttonProps = _ref$buttonProps === undefined ? noop : _ref$buttonProps,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSmartControlled = useSmartControlled(0, activeProp, onPageChange),
    _useSmartControlled2 = _slicedToArray(_useSmartControlled, 2),
    active = _useSmartControlled2[0],
    onChange = _useSmartControlled2[1];
  var handlePageClick = function handlePageClick(page) {
    return function () {
      return onChange(page);
    };
  };
  var renderPages = _toConsumableArray(Array(pages)).map(function (x, i) {
    var pageNro = i + 1;
    if (pages < 8) {
      return true;
    }
    if (active === pageNro) {
      // active page
      return true;
    }
    if (pageNro === 1 || pageNro === pages) {
      // first or last page
      return true;
    }
    if (pageNro + 1 === active || pageNro - 1 === active) {
      // next or prev page
      return true;
    }
    if (active < 5 && pageNro < 6) {
      return true;
    }
    if (active + 4 > pages && pageNro > pages - 5) {
      return true;
    }
    return false;
  });
  var theme = useTheme();
  var paginationTheme = theme.pagination.web;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement("nav", {
    role: "navigation",
    "aria-label": ariaLabel
  }, /*#__PURE__*/React.createElement(pagination, _extends({
    "data-testid": "elemental-Pagination"
  }, props), /*#__PURE__*/React.createElement(item, null, /*#__PURE__*/React.createElement(button, _extends({
    "data-testid": "elemental-Pagination-prev",
    disabled: active === 1 || pages === 0,
    onClick: handlePageClick(active - 1),
    type: "button",
    $color: color ? color : paginationTheme.color,
    "aria-label": ariaGotoPreviousLabel,
    as: tag
  }, buttonProps(active - 1)), /*#__PURE__*/React.createElement(IconChevronRight, {
    size: 24,
    color: color ? color : paginationTheme.color
  }))), renderPages.map(function (renderPage, i) {
    var renderTruncated = !renderPages[i] && renderPages[i - 1];
    var pageNo = i + 1;
    if (renderPage) {
      return /*#__PURE__*/React.createElement(item, {
        key: pageNo,
        "data-testid": "elemental-Pagination-li-".concat(pageNo).concat(active === pageNo ? '-active' : '')
      }, /*#__PURE__*/React.createElement(button, _extends({
        "data-testid": "elemental-Pagination-".concat(pageNo),
        $active: active === pageNo,
        onClick: handlePageClick(pageNo),
        type: "button",
        $color: color ? color : paginationTheme.color,
        "aria-label": "".concat(ariaGotoPageLabel, " ").concat(pageNo),
        "aria-current": active === pageNo,
        as: tag
      }, buttonProps(pageNo)), pageNo));
    }
    if (renderTruncated) {
      return /*#__PURE__*/React.createElement(item, {
        key: pageNo,
        "data-testid": "elemental-Pagination-li-".concat(pageNo, "-truncated")
      }, /*#__PURE__*/React.createElement(truncated, null, "..."));
    }
    return null;
  }), /*#__PURE__*/React.createElement(item, null, /*#__PURE__*/React.createElement(button, _extends({
    "data-testid": "elemental-Pagination-next",
    disabled: active === pages || pages === 0,
    onClick: handlePageClick(active + 1),
    type: "button",
    $color: color ? color : paginationTheme.color,
    "aria-label": ariaGotoNextLabel,
    as: tag
  }, buttonProps(active + 1)), /*#__PURE__*/React.createElement(IconChevronRight, {
    size: 24,
    color: color ? color : paginationTheme.color
  }))))));
};

export { Pagination };
